
























































































import Vue from 'vue';
import Component from 'vue-class-component';
import UnityBridge from '../unity-bridge';
import FavoriteHelper from '@/services/favorite-helper';
import Bro from 'brototype';

@Component
export default class MainMenu extends Vue {

    private ub: UnityBridge;

    constructor() {
        super();
        this.ub = new UnityBridge();
    }

    public get showDebug() {
        return false;// process.env.VUE_APP_DEBUG === 'enabled';
    }

    public openPois() {
        FavoriteHelper.RemoveFavoritFilterIfAny(this.$store);
        if (Bro(this.$f7).doYouEven('views.main.router')) {
            this.$f7.views.main.router.navigate('/pois/');
        }
    }

    public appRate() {
        this.ub.send('appRate');
    }

    public appRecommend() {
        this.ub.send('setLanguage', this.$store.settings.language);
        this.ub.send('appRecommend');
    }

}
